import { useSelector } from 'react-redux';
import { getRequestedQuery } from 'b2b-apps/shop/catalog/redux/search/selectors';

export type UseSearchRequestedQueryReturnType = string;
export function useSearchRequestedQuery(): UseSearchRequestedQueryReturnType {
  return useSelector(getRequestedQuery);
}
